/* eslint-disable no-unused-vars */
const ALCHEMY_API_URL = process.env.NEXT_PUBLIC_ALCHEMY_API_URL || "";

import { AbiItem } from "web3-utils";
import axios from "axios";

import Recruiting from "../../contracts/Recruiting.json";

import { UseToastOptions } from "@chakra-ui/toast";

import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import { getManyEntities, ownedRaidersIds } from "./interactBank";
import { Raider } from "../../types/raider";
const web3 = createAlchemyWeb3(ALCHEMY_API_URL);

export const getAccount = async () => {
	if ((window as any).current_provider) {
		web3.setWriteProvider((window as any).current_provider)
		if ((window as any).current_provider.isMetaMask) {
			//metamask
			return (window as any).current_provider.selectedAddress
		} else {
			return (window as any).current_provider.accounts[0];
		}
	} 
};

const recruitingContract = new web3.eth.Contract(
	Recruiting.abi as AbiItem[],
	process.env.NEXT_PUBLIC_RECRUITING
);

export const nextRecruitTime = async (raiderId: number) => {
	try {
		const result = await recruitingContract.methods
			.nextRecruitTime(raiderId)
			.call();
		return result;
	} catch (err) {
		console.log(err);
	}
};

export const canRaiderRecruit = async (raiderId: number): Promise<boolean> => {
	try {
		const result = await recruitingContract.methods
			.canRaiderRecruit(raiderId)
			.call();
		return result;
	} catch (err) {
		return false
	}
};

export const getNextGenToRecruit = async (raiderId: number) => {
	try {
		const result = await recruitingContract.methods
			.nextRaiderRecruitGeneration(raiderId)
			.call();
		return result;
	} catch (err) {
		console.log(err);
	}
};

export const getNextRecruitTime = async (raiderId: number) => {
	try {
		const result = await recruitingContract.methods
			.nextRecruitTime(raiderId)
			.call();
		return result;
	} catch (err) {
		console.log(err);
	}
};

export const getRecruitmentCost = async (raiderId: number) => {
	try {
		const result = await recruitingContract.methods
			.getRaiderRecruitCost(raiderId)
			.call();
		return result;
	} catch (err) {
		console.log(err);
	}
};

export const recruitRaider = async (
	raiderId: number,
	toast: (options: UseToastOptions) => string | number | undefined
) => {
	try {
		const account = await getAccount();
		const result = await recruitingContract.methods
			.recruitRaider(raiderId)
			.send(
				{ from: account, maxPriorityFeePerGas: null, maxFeePerGas: null },
				function (err: any, res: any) {
					if (err) {
						toast({
							title: "Couldn't recruit...",
							description: err.message,
							status: "error",
							duration: 9000,
							position: "top",
							isClosable: true,
						});
						console.log(err);
					} else {
						toast({
							title: "Raider recruited!",
							description:
								"Your new raider is being recruited, and will show up next time you log in to the Play site to run a dungeon.",
							status: "success",
							duration: 9000,
							position: "top",
							isClosable: true,
						});
					}
					console.log("Hash of the transaction: " + res);
				}
			);
		return result;
	} catch (err) {
		console.log(err);
	}
};

export const raidersWhoCanRecruit = async () => {
	const raiders = await ownedRaidersIds();

	let recruitable = [];

	for (let i = 0; i < raiders.length; i++) {
		if (await canRaiderRecruit(raiders[i])) {
			recruitable.push(raiders[i]);
		}
	}

	return recruitable;
};

interface RecruitmentStatus {
	recruitable: Raider[];
	unrecruitable: Raider[];
}

export const getRecruitmentStatus = async (owned_raider_ids: number[]): Promise<RecruitmentStatus> => {
	const recruitable = [] as number[];
	const unrecruitable = [] as number[];

	//This should probably be cached somewhere...
	const calls = owned_raider_ids.map(raider_id => canRaiderRecruit(raider_id))
	const responses = await Promise.all(calls)
	responses.forEach((result, index) => {
		if (result) {
			recruitable.push(owned_raider_ids[index])
		} else {
			unrecruitable.push(owned_raider_ids[index])
		}
	})
	const response_hash = {
		recruitable: [],
		unrecruitable: []
	} as RecruitmentStatus;

	(await getManyEntities(owned_raider_ids,'raiders') as Raider[]).forEach(raider => {
		if (recruitable.includes(Number(raider.id))) {
			response_hash.recruitable.push(raider)
		} else {
			response_hash.unrecruitable.push(raider)
		}
	})
	return response_hash;
};
